/**
 * JSON-LD pour les pages combo Panne × Ville.
 * Service avec areaServed = City spécifique (excellent pour SEO local).
 */
export const buildPanneVilleSchema = (combo) => {
  const { panne, city } = combo;
  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Service",
        serviceType: `${combo.panneShort} à ${city.name}`,
        name: `${combo.panneShort} - habitants de ${city.name}`,
        description: combo.metaDescription,
        category: panne.category,
        provider: {
          "@type": "LocalBusiness",
          "@id": "https://www.mediastore79.com/#localbusiness",
          name: "Mediastore Niort",
          address: {
            "@type": "PostalAddress",
            streetAddress: "104 Rue de la Gare",
            addressLocality: "Niort",
            postalCode: "79000",
            addressCountry: "FR",
          },
          telephone: "+33549057490",
          url: "https://www.mediastore79.com",
          aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: "4.6",
            reviewCount: "212",
            bestRating: "5",
          },
        },
        areaServed: {
          "@type": "City",
          name: city.name,
          postalCode: city.postalCode,
          containedInPlace: {
            "@type": "AdministrativeArea",
            name: "Deux-Sèvres",
          },
        },
        offers: {
          "@type": "AggregateOffer",
          priceCurrency: "EUR",
          lowPrice: String(panne.priceFrom),
          highPrice: String(panne.priceTo),
          offerCount: String(panne.pricing.length),
        },
      },
      {
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: `Combien de temps pour venir de ${city.name} à Mediastore Niort pour cette panne ?`,
            acceptedAnswer: {
              "@type": "Answer",
              text: `${city.name} est à ${city.distanceKm} km de notre boutique (${city.timeMinutes} minutes par ${city.accessRoad}). Pour ${combo.panneShort.toLowerCase()}, intervention en ${panne.durationLabel}. Click & Collect avec expédition Colissimo gratuit > 49 € disponible.`,
            },
          },
          ...panne.faqs.slice(0, 3).map((f) => ({
            "@type": "Question",
            name: f.q,
            acceptedAnswer: { "@type": "Answer", text: f.a },
          })),
        ],
      },
    ],
  };
};
